import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const BrandsBreadcrumbs = () : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Бренды',
        url: '',
    },
]);
